import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';

// Our Axios Instance
import axiosInstance from 'services/API/API';

// Our Endpoints
import { walletOverviewUrl } from 'shared/api-urls';

// Our Query Keys
import { WALLET_OVERVIEW_DATA } from 'shared/query-keys';

// our constants
import { DEFAULT_STALE_TIME_FIVE_MINUTES } from 'shared/constants';

function useGetWalletOverview(select) {
	const { clientId } = useParams();

	const endpointBasedOnClientId = clientId
		? `${walletOverviewUrl}/${clientId}`
		: walletOverviewUrl;

	const DYNAMIC_WALLET_OVERVIEW_QUERY_KEY = clientId
		? [WALLET_OVERVIEW_DATA, clientId]
		: WALLET_OVERVIEW_DATA;

	return useQuery(
		DYNAMIC_WALLET_OVERVIEW_QUERY_KEY,
		async () => {
			const response = await axiosInstance.get(endpointBasedOnClientId);
			const clientWalletOverviewData = response.data.data;
			return clientWalletOverviewData;
		},
		{
			select: (walletOverviewData) => {
				if (select) return select(walletOverviewData);
				return walletOverviewData;
			},
			staleTime: DEFAULT_STALE_TIME_FIVE_MINUTES,
			refetchOnWindowFocus: false
		}
	);
}

export default useGetWalletOverview;
